import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'alertDialog',
  templateUrl: 'alert.html'
})
export class AlertDialog {
  public message: string;
  constructor(public dialogRef: MatDialogRef<AlertDialog>) {}

  okayButtonClick = $event => {
    setTimeout(() => {
      this.dialogRef.close();
    }, 500);
  };
}
